import React from 'react';
const ProcessLoader = ({ pmMessage }) => {
  return (
    <div className="d-flex justify-content-center align-items-center d-none" id="process-loader">
      <div className="spinner-border text-primary process-loader-size" role="status">&nbsp;</div>
      <span className="process-loader-message">{pmMessage}</span>
    </div>
  );
};
export default ProcessLoader;
